// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8rU1t","box":"styles_box__IeLry","label":"styles_label__XWCo2"};